import { render, staticRenderFns } from "./Verzenden.vue?vue&type=template&id=625ba7d8&scoped=true"
import script from "./Verzenden.vue?vue&type=script&lang=js"
export * from "./Verzenden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ba7d8",
  null
  
)

export default component.exports